<div class="card calendar-card shadow-sm border-0">
  <!-- Header -->
  <div class="card-header">
    <div>
      <i class="fa-solid fa-calendar-day custom-icon-color"
      style="margin-right: 8px;"
      ></i>
      <span >
        Select Date From Available Slots
      </span>
    </div>
  </div>

  <!-- Calendar Body -->
  <div class="card-body px-4">
    <!-- Navigation -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <button class="btn navigate-btn" (click)="navigateToPreviousMonth()">
        <i class="fa-solid fa-chevron-left custom-icon-color"></i>
        Prev
      </button>
      <h6 class="text-center m-0">{{ months[currentMonth] }} {{ currentYear }}</h6>
      <button class="btn navigate-btn" (click)="navigateToNextMonth()">
        Next <i class="fa-solid fa-chevron-right custom-icon-color"></i>

      </button>
    </div>

    <!-- Calendar Grid -->
    <table class="table table-bordered text-center calendar-grid">
      <thead>
        <tr>
          <th *ngFor="let day of daysOfWeek">{{ day }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let week of weeks">
          <td
            *ngFor="let date of week"
            [class.text-muted]="!date.isCurrentMonth"
            [class.active]="isSelectedDate(date.date)"
            [class.today]="isToday(date.date)"
            [class.available]="isAvailable(date.date)"
            [class.disabled]="!isAvailable(date.date)"
            (click)="selectDate(date.date, date)"
            [style.pointer-events]="isAvailable(date.date) ? 'auto' : 'none'"
          >
            {{ date.day }}
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Available Slots -->
    <!-- <div *ngIf="selectedDate" class="mt-4">
      <h5 class="text-center text-dark fw-bold">
        Available Slots for {{ formatDateForDisplay(selectedDate) }}
      </h5>
      <div class="row row-cols-2 row-cols-md-3 g-3 mt-3">
        <div
          class="col"
          *ngFor="let slot of availableSlots[(selectedDate | date: 'yyyy-MM-dd') || ''] || []"
        >
          <button
            class="btn btn-primary btn-sm w-100 rounded-pill"
            [class.active]="selectedSlot === slot"
            (click)="selectSlot(slot)"
          >
            {{ slot }}
          </button>
        </div>
      </div>
    </div> -->

    <!-- Selected Slot Confirmation -->
    <!-- <div *ngIf="selectedSlot" class="mt-4 text-center">
      <p class="text-success fw-bold">
        You selected: {{ formatDateForDisplay(selectedDate!) }} at {{ selectedSlot }}
      </p>
      <button class="btn btn-success btn-sm rounded-pill px-4 mt-2">
        Confirm Appointment
      </button>
    </div> -->
  </div>
</div>
